/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_RequestingInputs */

const th_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังขออนุญาต`)
};

const en_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requesting permission`)
};

const ja_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可を確認中`)
};

const zh_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在请求权限`)
};

const es_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitando permiso`)
};

const pt_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedindo permissão`)
};

const id_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meminta izin`)
};

const fr_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demande d’autorisation`)
};

const tl_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Humihingi ng pahintulot`)
};

const vi_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xin quyền`)
};

const ko_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`권한 요청 중`)
};

const de_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigung wird angefragt`)
};

const ru_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрашиваем разрешение`)
};

const tr_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzin isteniyor`)
};

const it_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiesta del permesso`)
};

const pl_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prośba o zgodę`)
};

const uk_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запитуємо дозвіл`)
};

const hi_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमति माँगी जा रही है`)
};

const ar_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طلب الإذن`)
};

const ms_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meminta kebenaran`)
};

const bn_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুমতি চাওয়া হচ্ছে`)
};

const zh_tw2_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在要求權限`)
};

const zh_hk2_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在要求權限`)
};

const ur_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجازت مانگی جا رہی ہے`)
};

const fa_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال درخواست اجازه`)
};

const sw_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaomba ruhusa`)
};

const nl_video_requesting = /** @type {(inputs: Video_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestemming vragen`)
};

/**
* | output |
* | --- |
* | "Requesting permission" |
*
* @param {Video_RequestingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_requesting = /** @type {((inputs?: Video_RequestingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_RequestingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_requesting(inputs)
	if (locale === "ja") return ja_video_requesting(inputs)
	if (locale === "zh") return zh_video_requesting(inputs)
	if (locale === "es") return es_video_requesting(inputs)
	if (locale === "pt") return pt_video_requesting(inputs)
	if (locale === "id") return id_video_requesting(inputs)
	if (locale === "fr") return fr_video_requesting(inputs)
	if (locale === "tl") return tl_video_requesting(inputs)
	if (locale === "vi") return vi_video_requesting(inputs)
	if (locale === "ko") return ko_video_requesting(inputs)
	if (locale === "de") return de_video_requesting(inputs)
	if (locale === "ru") return ru_video_requesting(inputs)
	if (locale === "tr") return tr_video_requesting(inputs)
	if (locale === "it") return it_video_requesting(inputs)
	if (locale === "pl") return pl_video_requesting(inputs)
	if (locale === "uk") return uk_video_requesting(inputs)
	if (locale === "hi") return hi_video_requesting(inputs)
	if (locale === "ar") return ar_video_requesting(inputs)
	if (locale === "ms") return ms_video_requesting(inputs)
	if (locale === "bn") return bn_video_requesting(inputs)
	if (locale === "zh-TW") return zh_tw2_video_requesting(inputs)
	if (locale === "zh-HK") return zh_hk2_video_requesting(inputs)
	if (locale === "ur") return ur_video_requesting(inputs)
	if (locale === "fa") return fa_video_requesting(inputs)
	if (locale === "sw") return sw_video_requesting(inputs)
	if (locale === "nl") return nl_video_requesting(inputs)
	return en_video_requesting(inputs)
});